<template>
    <b-modal :id="modalId" no-close-on-backdrop title="Add Task" hide-footer>
        <loading-screen :is-loading="isSaving"></loading-screen>
        <errors :error-list="serverErrors"></errors>

        <!-- Create new task -->
        <div>
            <form @submit.prevent="createNewTask">

                <div class="form-group mb-4">
                    <label>Assign The Task To</label>
                    <b-form-radio-group v-model="assignTo">
                        <b-form-radio value="the-ticket">The Ticket</b-form-radio>
                        <b-form-radio value="me">Me</b-form-radio>
                    </b-form-radio-group>
                </div>

                <div class="form-group mb-4">
                    <label>Description</label>
                    <textarea v-model="newTask.description" name="description" id="description" rows="2"
                        class="form-control"></textarea>
                </div>

                <div class="form-group mb-4">
                    <label for="deadline">Due By</label>
                    <date-picker v-model="newTask.deadline" :config="datePickerOptions"></date-picker>
                </div>

                <div class="form-group mb-4" v-show="newTask.deadline">
                    <label for="alert_minutes_before_deadline">Alert Before Due</label>
                    <v-select :reduce="minutes => minutes.value" :clearable="false"
                        :options="alertMinutesBeforeDeadlineOptions"
                        v-model="newTask.alert_minutes_before_deadline"></v-select>
                </div>

                <button type="submit" class="btn btn-itg-dark" :disabled="isSaving" @click.prevent="createNewTask">Create
                    Task
                </button>

            </form>
        </div>
        <!-- / Create new task -->

    </b-modal>
</template>

<script>
import axios from "axios";
import Forms from "../../../../../mixins/Forms";
import Tasks from "../../../../../mixins/Tasks";
import { mapGetters, mapActions } from "vuex";

export default {
    name: "CreateTaskModal",
    props: ['selectedText', 'ticketNoteId'],
    data() {
        return {
            isLoading: false,
            isSaving: false,
            serverErrors: [],

            assignTo: 'the-ticket',

            newTask: {
                description: '',
                deadline: null,
                alert_minutes_before_deadline: null
            },

            datePickerOptions: {
                format: 'DD/MM/YYYY HH:mm'
            }
        }
    },
    watch: {
        selectedText() {
            this.newTask.description = this.selectedText.trim();
        }
    },
    mixins: [Forms, Tasks],
    methods: {
        ...mapActions('ticketViewer', ['reloadTicket']),

        createNewTask() {
            let vm = this;
            vm.serverErrors = [];
            vm.isSaving = true;

            let params = {
                ...this.newTask,
                alert_minutes_before_deadline: this.newTask.deadline !== null ? this.newTask.alert_minutes_before_deadline : null,
                deadline: this.newTask.deadline ? moment.tz(this.newTask.deadline, 'DD/MM/YYYY HH:mm', window.itgTimezone).utc().format('YYYY-MM-DD HH:mm:ss') : null
            };

            if (this.assignTo === 'the-ticket') {
                params.agent_id = null;
            }

            axios.post(API_BASE + '/tickets/' + this.ticket.id + '/tasks', params).then(r => {
                vm.isSaving = false;
                vm.newTask = {
                    description: ''
                };
                this.$notify.success({
                    title: 'Success!',
                    message: 'Task added successfully'
                });
                // this.$emit('task-added');
                this.reloadTicket();
                this.$bvModal.hide(this.modalId);
            }).catch(e => {
                console.log(e);
                vm.isSaving = false;
                vm.setErrors(e);
            });
        }
    },
    computed: {
        ...mapGetters('ticketViewer', {
            ticket: 'ticket'
        }),

        modalId() {
            return 'create-task-right-click-modal-' + this.ticketNoteId;
        }
    }
}
</script>

<style scoped></style>
